<template>
    <app-wrapper :loan="loan">
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="md:text-center md:w-full">
                    <h4 class="name">Congratulations {{ loan.user.first_name }}!</h4>
                    You are approved for the following terms.
                </div>
            </template>
            <template #bottom-left>
                <div>Loan Amount:</div>
                <div>Payback Period:</div>
                <div>First Payment:</div>
                <div>{{ loan.frequency | ucfirst }} Payments:</div>
            </template>
            <template #bottom-right>
                <div>{{ loan.amount | money(0) }}</div>
                <div>{{ loan.term }} months</div>
                <div>{{ loan.first_payment | money(2) }}</div>
                <div>{{ loan.remaining_payment | money(2) }}</div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-500" footer>

            <template #main>
                <div class="flex items-center mb-8">
                    <div class="flex-1">
                        <h4 class="title">
                            Your funds are on the way!
                        </h4>
                        <p class="text">
                            Thank you for choosing {{ $root.app.name }}.
                        </p>
                        <p class="text" v-if="afterSpecialHours">
                            You will receive your funds within 2 business days.
                        </p>
                        <p class="text" v-else>
                            You will receive your funds within 24 hours.
                        </p>
                    </div>
                </div>
            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import Moment from 'moment';

export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    props: ['loan'],

    data() {
        return {
            gTagPageName: 'loan-scheduled',
        }
    },

    created() {
        
    },

    computed: {
        afterSpecialHours() {
            return Moment().isAfter(Moment().hour(17).minute(0).second(0));
        }
    },
}
</script>
